/**
 * Generated bundle index. Do not edit.
 */
export { Modal, JSNativeModalContext, JSNativeModalContextBuilder, JSNativeModalRenderer, JSNativePresetBuilder, JSNativeModalModule, providers } from './js-native';
//# sourceMappingURL=angular2-modal-js-native.ng-flat.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/plugins/js-native/src/angular2-modal-js-native.ng-flat.js
// module id = 7
// module chunks = 0